import * as angular from "angular";
import * as _ from "lodash";

export class SkillsDialogService {

  /* @ngInject */
  constructor(private $mdDialog) {}

  // ******************************
  // External methods
  // ******************************

  create(currentSkills, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-skill-dialog.html').default,
      controller: function ($scope) {

        const currentSkillsNames = _.map(currentSkills, (s) => {
          return s.name.toLowerCase();
        });

        $scope.header = 'Create New Skill';
        $scope.action = 'Submit';
        $scope.skill = {
          name: undefined,
          color: '#278BFF',
          active: true,
        };
        $scope.cancel = self.$mdDialog.cancel;

        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onNameChange = (name) => {
          name = name.toLowerCase();
          $scope.createSkillForm.name.$setValidity('exists', !_.includes(currentSkillsNames, name));
        }

        $scope.onColorChange = (color) => {
          $scope.skill.color = color;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.skill);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  edit(skill, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-skill-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Edit Skill';
        $scope.action = 'Update';
        $scope.disableName = true;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.skill = angular.copy(skill);

        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onColorChange = (color) => {
          $scope.skill.color = color;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide($scope.skill);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.skills')
  .service('skillsDialogService', SkillsDialogService);
